@if (items().length > 1) {
  <nav class="sav-crumbs" [class.sav-crumbs-on-dark]="variant() === 'on-dark'" aria-label="Breadcrumb">
    <ol>
      @for (item of items(); track item.label + $index; let isLast = $last) {
        <li>
          @if (item.path && !isLast) {
            <a [routerLink]="item.path">{{ item.label }}</a>
          } @else {
            <span class="sav-crumbs-current" aria-current="page">{{ item.label }}</span>
          }
        </li>
        @if (!isLast) {
          <li class="sav-crumbs-sep" aria-hidden="true">/</li>
        }
      }
    </ol>
  </nav>
}
